import React from 'react'
import styled from 'styled-components'
import ScrollAnimation from 'react-animate-on-scroll'
import { rgba } from 'polished'

import { white, black } from 'styles/colors'
import { media, mediaDown } from 'styles/media'
import { H3, H4, fontWeights, lineHeights } from 'styles/typography'
import * as spacing from 'styles/spacing'

import Section from 'components/Section'
import Wrapper from 'components/Wrapper'

const Container = styled.div`
  background-color: ${rgba(black, 0.4)};
  overflow: hidden;

  ${mediaDown.medium`
    text-align: center;
  `};
`

const Inner = styled.div`
  position: relative;
  z-index: 10;

  ${media.medium`
    display: flex;
    align-items: center;
    justify-content: space-between;
  `};
`

const Main = styled.main`
  position: static;

  ${mediaDown.medium`
    max-width: 500px;
    margin-left: auto;
    margin-right: auto;
  `};

  ${media.medium`
    padding-right: ${spacing.xxLarge};
    margin-bottom: 0;
    max-width: 580px;
  `};

  ${media.large`
    padding-right: 56px;
  `};

  ${media.xLarge`
    padding-right: 88px;
    max-width: 660px;
  `};
`

const Heading = styled(H3)`
  color: ${white};
  text-transform: uppercase;
  margin-bottom: ${spacing.medium};

  ${media.medium`
    margin-bottom: ${spacing.large};
  `};

  ${media.xLarge`
    margin-bottom: ${spacing.xLarge};
  `};
`

const Subheading = styled(H4)`
  color: ${white};
  font-weight: ${fontWeights.regular};
  line-height: ${lineHeights.base};
  margin-bottom: ${spacing.medium};

  &:last-child {
    margin-bottom: 0;
  }
`

const FigureWrap = styled.div`
  flex-shrink: 0;
  pointer-events: none;

  ${mediaDown.medium`
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    width: 400px;
    margin-bottom: -170px;
  `};

  ${media.medium`
    width: 440px;
    margin-top: -80px;
    margin-bottom: -80px;
  `};

  ${media.large`
    width: 520px;
    margin-top: -96px;
    margin-bottom: -96px;
  `};

  ${media.xLarge`
    width: 580px;
  `};
`

const FreeDevice = () => (
  <Container>
    <Section>
      <Wrapper>
        <Inner>
          <Main>
            <Heading as={ScrollAnimation} animateIn="fadeInUp" offset={0} animateOnce>
              Vuse+ members <br className="u-hide-medium-down" />
              get extra benefits
            </Heading>
            <Subheading as={ScrollAnimation} animateIn="fadeInUp" offset={0} delay={200} animateOnce>
              All Vuse+ members receive a new device with their first subscription order.
            </Subheading>
            <Subheading as={ScrollAnimation} animateIn="fadeInUp" offset={0} delay={400} animateOnce>
              Vuse+ platinum members receive additional 5% off on all orders.
            </Subheading>
          </Main>
          <FigureWrap as={ScrollAnimation} animateIn="fadeIn" offset={0} delay={600} animateOnce>
            <img
              src={`${process.env.BASE_PATH}/images/subscribe/free-device-mobile.png`}
              className="u-hide-medium-up"
              alt=""
            />
            <img
              src={`${process.env.BASE_PATH}/images/subscribe/free-device-desktop.png`}
              className="u-hide-medium-down"
              alt=""
            />
          </FigureWrap>
        </Inner>
      </Wrapper>
    </Section>
  </Container>
)

export default FreeDevice
